import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTerms } from '../../hooks/useTerms';
import { termsSummary } from '../../utils/terms';

const EXPLANATIONS = [
  'Sjåføren melder ankomst i appen. Tiden regnes fra avtalt tid eller ankomst, den som kommer sist, til lasting eller lossing er registrert.',
  'Bomtur er et gebyr når sjåføren møter opp, men ikke kan laste eller losse, for eksempel fordi stedet er stengt eller massene ikke er klare.',
  'Avbestiller du etter at en sjåfør er tildelt, kan et gebyr gjelde. Det avhenger av hvor lenge det er til avtalt tid.',
];

export default function TermsPage() {
  const navigate = useNavigate();
  const { terms } = useTerms();
  const lines = termsSummary(terms);

  return (
    <div style={styles.root}>
      <div style={styles.page}>
        <button style={styles.back} onClick={() => navigate(-1)}>← Tilbake</button>
        <h1 style={styles.h1}>Vilkår — ventetid, bomtur og avbestilling</h1>
        <p style={styles.intro}>Disse satsene gjelder for oppdrag som bestilles gjennom Tippi. Sjåføren kan kreve tillegg, og du som bestiller godkjenner eller bestrider kravet i appen.</p>
        {lines.map((line, i) => (
          <div key={line} style={styles.section}>
            <p style={styles.line}>{line}</p>
            <p style={styles.explain}>{EXPLANATIONS[i]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  root:    { minHeight: '100vh', background: '#f4f6fa', padding: '32px 20px' },
  page:    { maxWidth: 680, margin: '0 auto', background: '#fff', borderRadius: 12, padding: '36px 40px', boxShadow: '0 1px 10px rgba(0,0,0,0.07)' },
  back:    { background: 'none', border: 'none', color: '#555', fontSize: 14, cursor: 'pointer', padding: '0 0 16px', display: 'block' },
  h1:      { fontSize: 24, fontWeight: 700, color: '#1a1a2e', margin: '0 0 12px' },
  intro:   { fontSize: 14, color: '#444', lineHeight: 1.6, margin: '0 0 24px' },
  section: { marginBottom: 20 },
  line:    { fontSize: 15, fontWeight: 600, color: '#1a1a2e', margin: '0 0 4px', lineHeight: 1.5 },
  explain: { fontSize: 13, color: '#666', margin: 0, lineHeight: 1.5 },
};
